import { isMobile } from "react-device-detect"
import { imagenesAll } from "../asset/img"
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { GrAdd, GrSubtract } from "react-icons/gr";
import { useEffect, useRef, useState } from "react";
import { BeforeFooterDekstop, BeforeFooterMobile, IsMobileHeader, IsPcHeader } from "../componentes/Principales";
import { GoArrowDownLeft } from "react-icons/go";
import { GoArrowDownRight } from "react-icons/go";




export const Nosotros = () => {
  return (
    <>
      {isMobile ? <NosotrosMobile /> : <NosotrosDesktop />}
    </>
  )
}

const NosotrosDesktop = () => {
  useEffect(() => {
    document.title = "WAZ - nosotros";
  }, []);
  return (
    <div className="">
        <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
      {/* header */}
      <div className="d-flex w-100 d-flex justify-content-center align-items-centers m_bg_primary m_bg_nosotrosHeader ">
        <div className="d-flex flex-column justify-content-center align-items-start m_w_70 pe-5 me-5 py-5 my-5 ">
          <div className="d-flex flex-column m-0 p-0">
            <strong className="m_h1 m_text_secondary ">Impulsando marcas,</strong>
            <strong className="m_h1 m_text_orange ">inspirando cambio</strong>
          </div>
          <div className="m_w_70 m_text_secondary m_bs mt-4">
            <p>Nuestra misión es ser líderes en la transformación de marcas en Latinoamérica, creando experiencias cautivadoras que inspiran y emocionan, mientras nuestra visión nos impulsa a ser reconocidos por nuestra empatía y estrategias innovadoras que dejan huella en el mercado y en la audiencia.</p>
          </div>
        </div>
      </div>


      <div className="w-100"> 
        <CarouselNosotrosDesktop   /> 
      </div>
      {/* animacion experience */}
      
      <div className="scroll-vertical m_text_secondary d-none" >
        <div className="ma_nosotros_slide1 ma_slide">
          <div className="h-100 d-flex justify-content-center">
            <div className="m_w_80 mt-5 pt-5">
              <span className="mt-5 pt-5 m_h1">3</span>
              <p className="fs-2">emprendedoras</p>
              <p className="fs-2">apasionadas</p>
            </div>
          </div>
        </div>

        <div className="ma_nosotros_slide2 ma_slide">
          <div className="d-flex justify-content-center">
            <div className="m_w_80 mt-5 pt-5">
              <span className="mt-5 pt-5 m_h1">7</span>
              <p className="fs-2">años de</p>
              <p className="fs-2">experiencia</p>
            </div>
          </div>
        </div>

        <div className="ma_nosotros_slide3 ma_slide">
          <div className="d-flex justify-content-center">
            <div className="m_w_80 mt-5 pt-5">
              <span className="mt-5 pt-5 m_h1">+300</span>
              <p className="fs-2">after office</p>
            </div>
          </div>
        </div>
      </div>
{/* Valores */}

      <section className="container m_text_secondary">
        <div className="row">
          <div className="col-xl">
            <div className="">  <span className="m_bg_amarillo py-1 px-2 m_bs">EL PROPÓSITO DETRÁS DE WAZ</span></div>
            <h4 className="m_hl">¿Por qué dimos<br></br> el primer paso? <span><GoArrowDownRight className="m_bg_primary rounded-5 " /></span></h4>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-lg-6">
            <p className="">Hartas de ver cómo las empresas luchan por encontrar un verdadero socio en marketing y comunicación, nos propusimos romper el molde. Nos cansamos de las promesas vacías y de las múltiples agencias para cada necesidad. Decidimos hacer las cosas de manera diferente, ofreciendo calidad y un servicio integral que resuelva todas tus necesidades de marketing en un solo lugar.</p>
          </div>
        </div>
        <div className="row mt-5 pt-5">
          <div className="col-lg-8 mt-5">
            <div className="row text-black">
              <CardValores title="Pasión por la Inovación" text="Nos impulsa en todo lo que hacemos, buscando constantemente nuevas formas de sorprender y llevar la creatividad a nuevos límites." />
              <CardValores title="Compromiso" text="Estamos dispuestos a trabajar incansablemente por el éxito de quienes confían en nosotros, fusionando sus metas y valores con nuestra experiencia." />
            </div>
            <div className="row text-black">
              <CardValores title={"Excelencia Colaborativa"} text={"Consideramos a nuestros clientes como partes integrales de nuestro equipo colaborativo, trabajando juntos para alcanzar metas comunes."} />
              <CardValores title={"Adaptabilidad Constante"} text={"Nos comprometemos a ser ágiles, eficientes y adaptables en un público en constante cambio, ajustando nuestras estrategias."} />
            </div>
            <div className="row text-black">
              <CardValores title={"Responsabilidad Social"} text={"Queremos un mundo mejor y nos comprometemos a aportar nuestra experiencia para crear mensajes más respetuosos e inspiradores."} />
            </div>
          </div>
          <div className="col-lg">
            <div className="">
              <h4 className="m_hl"><GoArrowDownLeft className="m_bg_primary rounded-5 me-2 p-2 me-4" size={45}/>Valores</h4>
            </div>
          </div>
        </div>
      </section>

{/* Cortina */}
      <div className="m_h100vh w-100 d-flex flex-column justify-content-center align-items-center text-center m_bg_primary ma_nosotros_cortina_ceo">
          <span className="m_bg_orange py-1 px-2 rounded-2 m_text_white m_bs">SPEECH</span>
          <p className="m_ m_w_70 m_bl fs-1">“Nos esforzamos por superar tus <br></br> expectativas. Nuestro compromiso con <br></br>la excelencia y la calidad impulsa todo<br></br> lo que hacemos  en WAZ”</p>
      </div>

{/* integrantes */}
      <div className="d-flex flex-wrap my-5">
        <CardIntegrantes urlImg={imagenesAll.zaraith} name="Zaraith Rondon" rol="Comercial y Cuentas" carrera="Licenciada en Comunicación Social" />
        <CardIntegrantes urlImg={imagenesAll.aixa} name="Aixa Leutloff" rol="Estrategia y creatividad en Campañas  publicitarias" carrera="Licenciada en Comunicación Social" />
        <CardIntegrantes urlImg={imagenesAll.valentina} name="Valentina Cinat" rol="Branding y Creatividad" carrera="Diseñadora Industrial y gráfica" />
        <CardIntegrantes urlImg={imagenesAll.trinidad} name="Trinidad Fernandez" rol="Diseño Multimedia y de Apps" carrera="Diseñadora UX/UI" />
      </div>


    <BeforeFooterDekstop text1="Sumate a las marcas que"  text2="evolucionan, inspiran y" text3="marcan la diferencia." textBtn="Contactanos" />
    </div>
  )
}
const NosotrosMobile = () => {
  return (
    <div className="">

      <IsMobileHeader />
      <div className="w-100 m_bg_primary py-5 m_bg_nosotrosHeaderMobile ">
        <div className="w-100 h-75 d-flex justify-content-center">
          <div className="m_w_90 pb-3">
            <p className="m_text_secondary m_hm mt-5 pt-5">Impulsando marcas, <span className="m_text_orange">inspirando cambio</span></p>
            <p className="m_text_secondary m_bl">Nuestra misión es ser líderes en la transformación de marcas
               en Latinoamérica, creando experiencias cautivadoras que inspiran y emocionan, mientras 
               nuestra visión nos impulsa a ser reconocidos por nuestra empatía y estrategias innovadoras
              que dejan huella en el mercado y en la audiencia.</p>
          </div>
        </div>
      </div>
      <div className="">
        <CarouselNosotros   />
      </div>

      <div className="w-100 m_dfc my-5 py-5">
        <div className="m_w_90">
          <div className=""><span className="m_bg_amarillo m_text_secondary px-2 py-1 rounded-2">EL PROPÓSITO DETRÁS DE WAZ</span></div>
          <h4 className="m_hs m_h3 m_text_secondary mt-3">¿Por qué dimos el primer paso?</h4>
          <div className="w-100 text-end">
            <GoArrowDownLeft className="m_text_secondary m_bg_primary rounded-5 p-2" size={50}/>
          </div>
          <p className="m_text_secondary m_bl fs- ">Hartas de ver cómo las empresas luchan por encontrar un verdadero socio en marketing y comunicación, nos propusimos romper el molde. Nos cansamos de las promesas vacías y de las múltiples agencias para cada necesidad. Decidimos hacer las cosas de manera diferente, ofreciendo calidad y un servicio integral que resuelva todas tus necesidades de marketing en un solo lugar.</p>
        </div>
      </div>

      <div className="w-100 d-flex justify-content-center align-items-center flex-column">
        <div className="m_w_90 ">
          <div className="w-100 text-end">
            <h4 className="m_text_secondary m_hl"><GoArrowDownLeft className="m_text_secondary m_bg_primary rounded-5 p-2" size={50}/> Valores</h4>
          </div>
        </div>

        <ValoresCardMobile 
          title1="Pasión por la Innovación" 
          text1="Nos impulsa en todo lo que hacemos, buscando constantemente nuevas formas de sorprender y llevar la creatividad a nuevos límites."
          title2="Compromiso"
          text2=" Estamos dispuestos a trabajar incansablemente por el éxito de quienes 
                  confían en nosotros, fusionando sus metas y valores con nuestra experiencia."
          />

        <ValoresCardMobile
          title1={"Excelencia Colaborativa"}
          text1={"Consideramos a nuestros clientes como partes integrales de nuestro equipo colaborativo, trabajando juntos para alcanzar metas comunes."}
          title2={"Adaptabilidad Constante"}
          text2={"Nos comprometemos a ser ágiles, eficientes y adaptables en un público en constante cambio, ajustando nuestras estrategias."}
          />


          <div className="m_w_90 mt-5">
            <h5 className="m_bm fs-3 m_text_orange" style={{ height: '50px' }}>Responsabilidad Social</h5>
            <p className="m_bs">Queremos un mundo mejor y nos comprometemos a aportar nuestra experiencia para crear mensajes más respetuosos e inspiradores.</p>
          </div>
      </div>


      {/* integrantes */}
      <div className="d-flex flex-column m_dfc mt-5">
        <div className="my-4"><CardIntegrantes urlImg={imagenesAll.zaraith} name="Zaraith Rondon" rol="Comercial y Cuentas" carrera="Licenciada en Comunicón Social" /></div>
        <div className="my-4"><CardIntegrantes urlImg={imagenesAll.aixa} name="Aixa Leutloff" rol="Estrategia y creatividad en Campañas publicitarias" carrera="Licenciada en Comunicón Social" /></div>
        <div className="my-4"><CardIntegrantes urlImg={imagenesAll.valentina} name="Valentina Cinat" rol="Branding y Creatividad" carrera="Diseñadora Industrial y gráfica" /></div>
        <div className="my-4"><CardIntegrantes urlImg={imagenesAll.trinidad} name="Trinidad Fernandez" rol="Diseño Multimedia y de Apps" carrera="Diseñadora UX/UI" /></div>
      </div>
      
      {/* Cortina*/}
      <div className="m_bg_primary m_dfc ma_nosotros_cortina_ceoMobile">
        <div className="m_w_90 m_dfc py-3 flex-column text-center">
          <div className=""><span className="m_bg_orange rounded-2 py-1 px-3 m_text_white m_tm">SPEECH</span></div>
          <p className="m_hs fs-2 mt-3">“Nos esforzamos por superar tus expectativas. Nuestro compromiso con la excelencia y la calidad impulsa todo lo que hacemos  en WAZ”</p>
        </div>
      </div>
      <BeforeFooterMobile text1="¿Te gustaría" text2="confirmar si" text3="hacemos match?" textBtn="Contactanos" />
    </div>
  )
}

const CardValores =({title, text})=>{
  return(
    <div className="col-2 m_card_valores my-3 mx-2 d-flex flex-column justify-content-center align-items-center text-center">
      <h5 className="mb-3 m_text_orange fs-2 m_bs text-start">{title}</h5>
      <p className="text-start">{text}</p>
    </div>
  )
}
const CardIntegrantes = ({ urlImg, name, rol, carrera }) => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  return (
    <article className="m_cardIntegrantes_ctn mx-3 position-relative">
      <div className="position-relative">
        {/* Botón flotante */}
        <button
          onClick={handleClick}
          className="position-absolute top-0 end-0 m-2 rounded-circle border-0 p-2 d-flex align-items-center justify-content-center d-none"
          style={{ zIndex: 2, backgroundColor: "#d9f750" }}
          aria-label={show ? "Ocultar redes sociales" : "Mostrar redes sociales"}
        >
          {show ? <GrSubtract aria-hidden="true" /> : <GrAdd aria-hidden="true" />}
        </button>

        {/* Redes sociales */}
        <div
          className="position-absolute me-3 pt-3 top-0 end-0 mt-5 me-2 d-flex flex-column align-items-center"
          style={{ zIndex: 1 }}
        >
          {show && (
            <>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Perfil de LinkedIn de ${name}`}
                className="m_pointer m_dfc mb-2  m_card_icons m_bg_primary m_text_secondary shadow"
              >
                <FaLinkedinIn aria-hidden="true" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Perfil de Facebook de ${name}`}
                className="m_pointer m_dfc m_card_icons m_bg_primary m_text_secondary shadow"
              >
                <FaFacebookF aria-hidden="true" />
              </a>
            </>
          )}
        </div>

        {/* Imagen */}
        <img
          className="rounded-3 w-100"
          src={urlImg}
          alt={`Foto de ${name}`}
        />
      </div>

      {/* Info */}
      <div className="mt-3 d-flex flex-column justify-content-between align-items-start">
        <span className="m_text_secondary">• {carrera}</span>
        <h2 className="fs-3 m_bl mt-2">{name}</h2>
        <p className="fw-bold mb-0">{rol}</p>
      </div>
    </article>
  );
};
const ValoresCardMobile = ({title1, title2, text1, text2}) => {
  return (
    <div className="m_w_90 d-flex mt-5">
      <div className="w-50 me-2">
        <h5 className="m_bm fs-3 m_text_orange" style={{ height: '70px' }}>
          {title1}
        </h5>
        <p className="m_bs">
          {text1}
        </p>
      </div>
      <div className="w-50 ms-2">
        <h5 className="m_text_orange m_bm fs-3" style={{ height: '70px' }}>
          {title2}
        </h5>
        <p className="m_bs">
         {text2}
        </p>
      </div>
    </div>
  );
};


const slides2 = [
  {
    id: 1,
    className: "ma_nosotros_carrusel_slide111 h-100 m_100vw",
    number: "3",
    text: "emprendedoras\napasionadas",
  },
  {
    id: 2,
    className: "ma_nosotros_carrusel_slide211 h-100 m_100vw",
    number: "7",
    text: "años de\nexperiencia",
  },
  {
    id: 3,
    className: "ma_nosotros_carrusel_slide311 h-100 m_100vw",
    number: "+300",
    text: "after office",
  },

];
const slides = [
  {
    id: 1,
    className: "ma_nosotros_carrusel_slide11 h-100 m_100vw",
    number: "3",
    text: "emprendedoras\napasionadas",
  },
  {
    id: 2,
    className: "ma_nosotros_carrusel_slide21 h-100 m_100vw",
    number: "7",
    text: "años de\nexperiencia",
  },
  {
    id: 3,
    className: "ma_nosotros_carrusel_slide31 h-100 m_100vw",
    number: "+300",
    text: "after office",
  },

];


const CarouselNosotros = () => {
 const [index, setIndex] = useState(0);

 useEffect(() => {
   const autoSlide = setInterval(() => {
     setIndex((prev) => (prev + 1) % slides.length);
   }, 3000);
   return () => clearInterval(autoSlide);
 }, []);

 return (
   <section className="ma_nosotros_carrusel_contenedorMobile m_text_secondary">
     <div
       className="ma_nosotros_carrusel_inner"
       style={{ transform: `translateX(-${index * 100}%)` }}
     >
       {slides.map((slide) => (
         <div
           key={slide.id}
           className={`ma_nosotros_carrusel_item ${slide.className}`}
         >
           <div className="ma_nosotros_carrusel_contenido">
             <span className="ma_nosotros_carrusel_numero">{slide.number}</span>
             <span className="ma_nosotros_carrusel_texto">
               {slide.text.split("\n").map((line, i) => (
                 <div key={i}>{line}</div>
               ))}
             </span>
           </div>
         </div>
       ))}
     </div>
   </section>
 );
};

const CarouselNosotrosDesktop = () => {
 const [index, setIndex] = useState(0);

 useEffect(() => {
   const autoSlide = setInterval(() => {
     setIndex((prev) => (prev + 1) % slides2.length);
   }, 4000);
   return () => clearInterval(autoSlide);
 }, []);

 return (
   <section className="ma_nosotros_carrusel_contenedor m_text_secondary">
     <div
       className="ma_nosotros_carrusel_inner h-100"
       style={{ transform: `translateX(-${index * 100}%)` }}
     >
       {slides2.map((slide) => (
         <div
           key={slide.id}
           className={`ma_nosotros_carrusel_item w-100 ${slide.className}`}
         >
           <div className="ma_nosotros_carrusel_contenido ms-5 ps-5">
             <span className="ma_nosotros_carrusel_numero">{slide.number}</span>
             <span className="ma_nosotros_carrusel_texto">
               {slide.text.split("\n").map((line, i) => (
                 <div key={i}>{line}</div>
               ))}
             </span>
           </div>
         </div>
       ))}
     </div>
   </section>
 );
};
